import apiFetch from '../apiFetch'

export default function (token) {
  return apiFetch({endPoint: `Combos/getComboRutasActivas`, method: 'GET', body: null, token: token})
}